import { render, staticRenderFns } from "./IntroxlRefiSamples.vue?vue&type=template&id=3d83320e"
import script from "./IntroxlRefiSamples.vue?vue&type=script&lang=js"
export * from "./IntroxlRefiSamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports